export const getProcessingFeeRowTitle = (currency: string | undefined) => {
    return currency?.toLocaleLowerCase() === "gbp" ? "Service fee" : "Processing fee";
};
